import {IResponseEntity} from '@toolify/server/src/services/EntityService/types/IResponseEntity'
import {EntityType} from '@toolify/server/src/services/EntityService/enum/EntityType'
import {getGuestDisplayInfo} from './getGuestDisplayInfo'

export function getEntityNameByEntity(entity: IResponseEntity) {
  if(!entity) {
    return null
  }
  if(entity.entityType === EntityType.User) {
    return (entity as IResponseEntity<EntityType.User>).payload?.nick
  }
  if(entity.entityType === EntityType.Bot) {
    return 'Bot'
  }
  if(entity.entityType === EntityType.Guest) {
    return getGuestDisplayInfo((entity as IResponseEntity<EntityType.Guest>).entityId).name
  }
  if(entity.entityType === EntityType.System) {
    return `${ENV.AppBrandingName} AI`
  }
  if(entity.entityType === EntityType.App) {
    const payload = (entity as IResponseEntity<EntityType.App>).payload
    return payload?.name || null
  }
  if(entity.entityType === EntityType.Agent) {
    const payload = (entity as IResponseEntity<EntityType.Agent>).payload as {title?: string|null; name?: string}
    return payload?.title || payload?.name || null
  }
  return 'System'
}
